import { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useAuth } from "../../context/AuthContext"; // sesuaikan path

export default function FormDataSiswa({ onClose, onSuccess, editData }) {
  const { token } = useAuth(); // ← pakai session token

  const [form, setForm] = useState({
    no_absen: "",
    nisn: "",
    nama_lengkap: "",
    jenis_kelamin: "",
    no_hp_ortu: "",
    id_kelas: "",
    openKelas: false,
  });

  const [kelas, setKelas] = useState([]);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0, width: 0 });
  const kelasButtonRef = useRef(null);

  useEffect(() => {
    axios
      .get("https://backend.smpn1kamal.sch.id/api/kelas", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setKelas(res.data))
      .catch(() => toast.error("Gagal ambil data kelas"));

    if (editData) {
      setForm({
        no_absen: editData.no_absen ?? "",
        nisn: editData.nisn ?? "",
        nama_lengkap: editData.nama_lengkap ?? "",
        jenis_kelamin: editData.jenis_kelamin ?? "",
        no_hp_ortu: editData.no_hp_ortu ?? "",
        id_kelas: String(editData.id_kelas),
        openKelas: false,
      });
    }
  }, [editData, token]);

  const handleOpenKelas = () => {
    if (kelasButtonRef.current) {
      const rect = kelasButtonRef.current.getBoundingClientRect();
      setDropdownPos({
        top: rect.bottom + 8,
        left: rect.left,
        width: rect.width,
      });
    }
    setForm((prev) => ({ ...prev, openKelas: !prev.openKelas }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.id_kelas) {
      toast.warning("Kelas wajib dipilih");
      return;
    }

    try {
      if (editData) {
        await axios.put(
          `https://backend.smpn1kamal.sch.id/api/datasiswa/${editData.id}`,
          form,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        toast.success("Siswa berhasil diupdate");
      } else {
        await axios.post(
          "https://backend.smpn1kamal.sch.id/api/datasiswa",
          form,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        toast.success("Siswa berhasil ditambahkan");
      }

      onSuccess();
      onClose();
    } catch {
      toast.error("Gagal menyimpan data");
    }
  };

  const kelasTerpilih = kelas.find(
    (k) => String(k.id_kelas) === form.id_kelas
  );

  return createPortal(
    <div
      className="fixed inset-0 bg-slate-900/60 backdrop-sm flex items-center justify-center z-[9999] p-3 sm:p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl w-full max-w-md sm:max-w-2xl md:max-w-3xl shadow-2xl flex flex-col"
        style={{ maxHeight: "calc(100vh - 32px)" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="flex items-center justify-between p-4 sm:p-6 pb-3">
          <h2 className="text-lg sm:text-xl font-bold text-slate-800">
            {editData ? "Edit Data Siswa" : "Tambah Siswa Baru"}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="text-slate-400 hover:text-slate-700 text-2xl font-bold leading-none"
          >
            &times;
          </button>
        </div>

        {/* FORM — scroll area */}
        <form
          onSubmit={handleSubmit}
          className="px-4 sm:px-6 pb-4 sm:pb-6 overflow-y-auto flex-1"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">

            {/* KIRI */}
            <div>
              <div className="mb-3">
                <label className="label">No Absen</label>
                <input
                  type="number"
                  className="input"
                  value={form.no_absen}
                  onChange={(e) => setForm({ ...form, no_absen: e.target.value })}
                />
              </div>

              <div className="mb-3">
                <label className="label">NISN</label>
                <input
                  className="input"
                  value={form.nisn}
                  onChange={(e) => setForm({ ...form, nisn: e.target.value })}
                />
              </div>

              <div className="mb-3">
                <label className="label">Nama Lengkap</label>
                <input
                  className="input"
                  value={form.nama_lengkap}
                  onChange={(e) => setForm({ ...form, nama_lengkap: e.target.value })}
                />
              </div>
            </div>

            {/* KANAN */}
            <div>
              <div className="mb-3">
                <label className="label">Jenis Kelamin</label>
                <select
                  className="input"
                  value={form.jenis_kelamin}
                  onChange={(e) => setForm({ ...form, jenis_kelamin: e.target.value })}
                >
                  <option value="">Pilih</option>
                  <option value="L">Laki-laki</option>
                  <option value="P">Perempuan</option>
                </select>
              </div>

              <div className="mb-3">
                <label className="label">No HP Orang Tua</label>
                <input
                  className="input"
                  value={form.no_hp_ortu}
                  onChange={(e) => setForm({ ...form, no_hp_ortu: e.target.value })}
                />
              </div>

              <div className="mb-3">
                <label className="label">Kelas</label>
                <button
                  ref={kelasButtonRef}
                  type="button"
                  onClick={handleOpenKelas}
                  className="input flex justify-between items-center"
                >
                  <span>
                    {kelasTerpilih ? kelasTerpilih.nama_kelas : "Pilih Kelas"}
                  </span>
                </button>
              </div>
            </div>
          </div>

          {/* ACTION */}
          <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3 mt-4">
            <button
              type="button"
              onClick={onClose}
              className="btn-secondary w-full sm:w-auto"
            >
              Batal
            </button>
            <button
              type="submit"
              className="btn-primary w-full sm:w-auto"
            >
              Simpan Data
            </button>
          </div>
        </form>
      </div>

      {/* DROPDOWN KELAS — di-render di luar modal pakai fixed, tidak akan terpotong */}
      {form.openKelas && createPortal(
        <>
          <div
            className="fixed inset-0 z-[10001]"
            onClick={() => setForm((prev) => ({ ...prev, openKelas: false }))}
          />
          <div
            className="fixed z-[10002] bg-white border rounded-xl shadow-xl max-h-48 overflow-y-auto"
            style={{
              top: dropdownPos.top,
              left: dropdownPos.left,
              width: dropdownPos.width,
            }}
          >
            {kelas.map((k) => (
              <div
                key={k.id_kelas}
                onClick={() =>
                  setForm((prev) => ({
                    ...prev,
                    id_kelas: String(k.id_kelas),
                    openKelas: false,
                  }))
                }
                className="px-4 py-2 hover:bg-slate-50 cursor-pointer"
              >
                {k.nama_kelas}
              </div>
            ))}
          </div>
        </>,
        document.body
      )}

      <style>
        {`
        .label {
          display: block;
          font-size: 12px;
          font-weight: 600;
          color: #64748b;
          margin-bottom: 4px;
          margin-left: 4px;
          text-transform: uppercase;
        }
        .input {
          width: 100%;
          border: 1px solid #e2e8f0;
          padding: 10px;
          border-radius: 12px;
          outline: none;
        }
        .input:focus {
          box-shadow: 0 0 0 2px #6366f1;
        }
        .btn-primary {
          background: #4f46e5;
          color: white;
          padding: 10px 16px;
          border-radius: 12px;
        }
        .btn-secondary {
          color: #475569;
          padding: 10px 16px;
          border-radius: 12px;
        }
        `}
      </style>
    </div>,
    document.body
  );
}